import _ from "lodash";
import React, { UIEventHandler } from "react";
import LayoutTabs from "./LayoutTabs";

/** add shadow effect on breadcrumb when scrolled */
const onScrollPageContent: UIEventHandler<HTMLDivElement> = _.throttle((event) => {
	const breadcrumbNode = document.getElementById("sectionShadow");
	const target = event.target as HTMLDivElement;
	breadcrumbNode.classList.toggle("csi-shadow-bottom", target.scrollTop > 0);
}, 250);

const PageContent = () => {
	return (
		<>
			<div id="sectionShadow" />
			<LayoutTabs id="pageContentScroll" onScroll={onScrollPageContent} />
		</>
	);
};

export default PageContent;